import { Image as ImageToExtend } from '@tiptap/extension-image';
import { NodeType } from '../constants';

export const Image = ImageToExtend
    .extend({
        addAttributes() {
            return {
                ...this.parent?.(),
                class: {
                    default: 'responsive',
                },
                style: {
                    default: null,
                },
            };
        },
        addCommands() {
            return {
                ...this.parent?.(),
                resetResponsive: (imageClasses) => ({ commands }) => {
                    const classes = imageClasses.replace(/responsive\s*/, '');
                    return commands.updateAttributes(NodeType.IMAGE, { class: classes })
                },
                setImageAlign: (className, imageClasses) => ({ commands }) => {
                    const valueToReplace = className === null ? '' : `${className} `;
                    const classes = imageClasses.replace(/(mar-\w+-\w+s*)|/, valueToReplace);
                    return commands.updateAttributes(NodeType.IMAGE, { class: classes });
                },
                setStyles: (styles) => ({ commands }) => {
                    const styleObjToString = () => Object
                        .entries(styles)
                        .reduce((acc, [styleName, style]) => `${acc}${styleName}:${style};`, '');
                    commands.updateAttributes(NodeType.IMAGE, { style: styleObjToString() });
                }
            };
        }
    });
